import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles, useTheme } from "@mui/styles";
import {
  Toolbar,
  Typography,
  IconButton,
  useMediaQuery,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {},
  flexGrow: {
    flexGrow: 1,
  },
  flex: {
    display: "flex",
    flexDirection: "row",
  },
  navigationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 65,
  },
  toolbar: {
    width: "100%",
    margin: "0 auto",
    padding: theme.spacing(1, 4),
  },
  listItem: {
    cursor: "pointer",
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItemText: {
    flex: "0 0 auto",
    whiteSpace: "nowrap",
    textDecoration: "none",
  },
  activeLink: {
    fontWeight: "bold",
    color: theme.palette.primary.light,
    whiteSpace: "nowrap",
    "&:hover": {
      background: "transparent",
      textDecoration: "none",
      color: theme.palette.primary.light,
    },
  },
  inActiveLink: {
    color: theme.palette.grey[700],
    whiteSpace: "nowrap",
    "&:hover": {
      background: "transparent",
      textDecoration: "none",
      color: theme.palette.grey[700],
    },
  },
  iconButton: {
    padding: 0,
    "&:hover": {
      background: "transparent",
    },
  },
  logoContainer: {
    width: 120,
    height: 65,
  },
  logoImage: {
    width: "100%",
    height: "100%",
  },
}));

const Topbar = (props) => {
  const { onSidebarOpen, ...rest } = props;

  let theme = useTheme();
  const classes = useStyles(theme);
  const matches = useMediaQuery(theme.breakpoints.up("lg"));

  // IconButton States and Functions
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Toolbar disableGutters className={classes.toolbar} {...rest}>
      {!matches && (
        <div className={classes.flex}>
          <IconButton
            className={classes.iconButton}
            onClick={onSidebarOpen}
            aria-label="Menu"
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.logoContainer}>
            <a href="/" title="Home">
              <img
                className={clsx("image", classes.root, classes.logoImage)}
                alt="Finsoft-Ai"
                src="/SSI_Logo.png"
              />
            </a>
          </div>
        </div>
      )}

      <div className={classes.flexGrow} />

      <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
        <Avatar sx={{ width: 48, height: 48 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          disableRipple
          className="border border-dark rounded mx-2 my-1"
          sx={{
            ml: 1,
            "&.MuiButtonBase-root:hover": {
              bgcolor: "transparent",
              pointerEvents: "none",
            },
          }}
        >
          <Typography className={classes.listItemText}>
            {new Date().toDateString()}
          </Typography>
        </MenuItem>

        <MenuItem
          disableRipple
          className="border border-dark rounded mx-2 my-1"
          sx={{
            ml: 1,
            "&.MuiButtonBase-root:hover": {
              bgcolor: "transparent",
              pointerEvents: "none",
            },
          }}
        >
          <Typography className={classes.listItemText}>
            <Typography className={classes.listItemText}>
              David Miller
            </Typography>
          </Typography>
        </MenuItem>
      </Menu>
    </Toolbar>
  );
};

Topbar.propTypes = {
  onSidebarOpen: PropTypes.func,
};

export default Topbar;
